var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"referral-submit-page",style:(_vm.customStyle)},[_c('ResumeEditor',{attrs:{"resumeEditorSetting":_vm.resumeEditorSetting,"hiddenSteps":_vm.hiddenSteps,"isReferral":true,"showUploadButton":false,"customPageInfo":_vm.customPageInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }